<template>
  <div class="latest_comments">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-6">
          <div class="section_title">
            <h1>
              <svg id="trend-up_linear" data-name="trend-up/linear" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g id="vuesax_linear_trend-up" data-name="vuesax/linear/trend-up">
                  <g id="trend-up">
                    <path id="Vector" d="M9,0,4.8,4.2,3.2,1.8,0,5" transform="translate(7.5 9.5)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Vector-2" data-name="Vector" d="M0,0H2V2" transform="translate(14.5 9.5)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Vector-3" data-name="Vector" d="M7,20h6c5,0,7-2,7-7V7c0-5-2-7-7-7H7C2,0,0,2,0,7v6C0,18,2,20,7,20Z" transform="translate(2 2)" fill="none" stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Vector-4" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                  </g>
                </g>
              </svg>

              <span>تقييمات شائعة</span>
            </h1>
          </div>
        </div>
        <div class="col-6"></div>
      </div>
      <div class="comments_wrapper">
        <div class="row" v-if="reviews.length">

          <RateObject v-for="review in reviews" :userShow="false" :placeShow="true" :key="review.id" :rate="review"
            @open-report="handleReport" />
        </div>
        <template v-else-if="loading">
          <div class="row">

            <!-- <h1>test</h1> -->
            <RateObjectPlaceholder v-for="n in 6" :key="n" :userShow="false" :placeShow="true" />
          </div>
        </template>
        <div class="moreLoading">
          <template v-if="nextPage">
            <a href="javascript:;" :class="{ 'loading': loading }" @click="loadMore"
              class="section_subtitle load-more has-spinner-link">
              <div class="button_text">عرض المزيد</div>
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
  <ReportRateModal ref="reportModalRef" dir="rtl" />
</template>


<script setup lang="ts">
defineProps({
  reviews: Array,
  nextPage: Number | null,
  loading: Boolean | false,
  loadMore: Function // Accept the function from the parent
});

import ReportRateModal from "@/components/ReportRateModal.vue";

const reportModalRef = ref < InstanceType < typeof ReportRateModal > | null > (null)

const handleReport = (ratingId: String) => {

  if (reportModalRef.value) {
    reportModalRef.value.setRatingId(ratingId)
    reportModalRef.value.openModal()
  }
}


</script>